import {arraysAreEqual} from './arraysAreEqual';

export function compareObjectFields<TLeft extends Record<string, unknown>, TRight extends Record<string, unknown>>(
  left: TLeft,
  right: TRight,
  customComparators?: {
    [K in keyof TLeft]?: (left: TLeft, right: TRight) => boolean;
  },
) {
  return Object.keys(left).reduce(
    (acc, key) => {
      if (customComparators?.[key]) {
        acc[key] = customComparators[key](left, right);

        return acc;
      }

      if (Array.isArray(left[key]) && Array.isArray(right[key])) {
        acc[key] = arraysAreEqual(left[key], right[key]);

        return acc;
      }

      acc[key] = left[key] === right[key];

      return acc;
    },
    Object.fromEntries(Object.keys(left).map((key) => [key, false])),
  );
}
